export enum Shift {
  DAY = "1",
  NIGHT = "3",
  GRAVEYARD = "5",
  COASTWISE = "67",
  SQUAMISH = "68",
}

export const Shifts: Shift[] = [
  Shift.DAY,
  Shift.NIGHT,
  Shift.GRAVEYARD,
  Shift.COASTWISE,
  Shift.SQUAMISH
];

export const decodeString = (shift: Shift) => {
  switch (shift) {
    case Shift.DAY:
      return "DAY";
    case Shift.NIGHT:
      return "NIGHT";
    case Shift.GRAVEYARD:
      return "GRAVEYARD";
    case Shift.COASTWISE:
      return "COASTWISE";
    case Shift.SQUAMISH:
      return "SQUAMISH";
    default:
      return shift;
  }
};

export const getDecodedShift = (shift: Shift) =>
  shift === "67" || shift === "68" ?
    "5:45 - " + decodeString(shift) :
    decodeString(shift);
